export default __webpack_public_path__ + "static/media/number.908e0e6f.jpg";